import React, { useState } from 'react'
import { TextInputField, Pane, Heading, Icon, toaster } from 'evergreen-ui'
import { connect } from 'react-redux'
import BtnDefault from '../../Components/BtnDefault'
import { handleLogin } from '../../Redux/reducers/auth'
import Register from '../Register/index';
import axios from '../../Utils/axios'
import { unsetLoading, setLoading } from '../../Redux/reducers/loading';
const LoginComponent = ({
  dispatch
}) => {
  const [formData, setFormData] = useState({ username: '', password: '' })
  const [isRegister, setIsRegister] = useState(false)

  async function login(user) {
    toaster.closeAll()
    if (!user.username || !user.password) {
      return toaster.danger('Informe usuário e senha')
    }

    dispatch(setLoading())
    try {
      const { data } = await axios.post('/accounts/signin', {
        email: username, password
      })

      dispatch(handleLogin(data))
    } catch (error) {
      if (error.response === undefined) {
        toaster.danger("Sem conexão")
      } else {
        toaster.danger(error.response.data.error.message)
      }
    }
    finally {
      dispatch(unsetLoading())
    }
  }
  const { username, password } = formData
  return (
    <div className='content'>
      <div className='login-div'>
        <form onSubmit={(e) => {
          e.preventDefault()
          login({ username, password })
        }}>
          <Pane flex={1} alignItems="center" display="flex">
            <Heading size={600}> <Icon icon="lock" color='gold' size={25} /> Faça Login para continuar </Heading>
          </Pane>
          <Pane flex={1} alignItems="center" marginTop={10}>
            <TextInputField
              label='Usuário'
              description=""
              name='username' placeholder='Usuário' value={username} onChange={({ target }) => setFormData({ ...formData, [target.name]: target.value })} />
            <TextInputField
              name='password'
              placeholder='Senha' label='Senha'
              type='password'
              value={password}
              onChange={({ target }) => setFormData({
                ...formData,
                [target.name]: target.value
              })}
              description="" />

            <BtnDefault
              icon='log-in'
              type='submit'
              height={40}
              appearance="primary"
              onClick={(e) => {
                e.preventDefault()
                login({ username, password })
              }}> Acessar </BtnDefault>
            <button style={{outline:'none', cursor: 'pointer', border: 'none' ,background: 'none', color:'#106DBC', fontWeight: 'bold'}}
              onClick={() => setIsRegister(true)}> <span> Ainda não tem login? Cadastre-se! </span></button>
          </Pane>
        </form>
      </div >
      <Register
        visible={isRegister}
        goBack={() => setIsRegister(false)} />

    </div>
  )
}
export default connect()(LoginComponent)


